import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import * as styles from './Error.module.scss'

function Error({ children, className }) {
  return <span className={classNames(styles.error, className)}>{children}</span>
}

Error.propTypes = {
  className: PropTypes.string,
}

export default Error
